/**
 * SEO & Public Link Helper for 909 Dental OPD
 * Converts clinic and doctor names into clean, readable, SEO-friendly slugs
 */

/**
 * Generate SEO friendly slug from a clinic entity
 * @param {Object} clinic - Clinic object with name, clinic_name, slug, id
 * @returns {string} Clean URL slug (e.g. '909-dental-opd-implant-centre')
 */
export const getClinicSeoSlug = (clinic) => {
  if (!clinic) return "909-dental-opd";

  const rawName = clinic.name || clinic.clinic_name;
  if (rawName && typeof rawName === 'string' && rawName.trim()) {
    const seoSlug = rawName
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');
    
    if (seoSlug && seoSlug.length >= 2) {
      return seoSlug;
    }
  }

  if (clinic.slug && !/^[a-z0-9]{5,8}$/i.test(clinic.slug)) {
    return clinic.slug;
  }

  return "909-dental-opd-clinic";
};

/**
 * Generate SEO friendly slug for Doctor
 * @param {Object} doctor - Doctor object with name, code, etc.
 * @returns {string} Clean doctor slug
 */
export const getDoctorSeoSlug = (doctor) => {
  if (!doctor) return "dr-dental-specialist";

  const name = doctor.name || doctor.doctor_name;
  if (name && typeof name === 'string' && name.trim()) {
    const cleanName = name.replace(/^dr\.?\s*/i, '').trim();
    const docSlug = `dr-${cleanName}`
      .toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');
    
    if (docSlug && docSlug.length >= 4) {
      return docSlug;
    }
  }

  return doctor.doctor_code ? doctor.doctor_code.toLowerCase() : "dr-dental-specialist";
};

export default {
  getClinicSeoSlug,
  getDoctorSeoSlug,
};
